import { gql } from "@apollo/client";

export const WHATSAPP_TEMPLATES_QUERY = gql`
  query WhatsAppTemplates($isActive: Boolean) {
    whatsappTemplates(isActive: $isActive) {
      id
      name
      displayName
      category
      languageCode
      parameterSchema
      status
      isActive
      campaignsCount
      bodyText
      headerFormat
      buttons
      createdAt
    }
  }
`;

export const WHATSAPP_CAMPAIGNS_QUERY = gql`
  query WhatsAppCampaigns($status: WhatsAppCampaignStatus) {
    whatsappCampaigns(status: $status) {
      id
      name
      template {
        id
        name
        displayName
      }
      status
      totalRecipients
      sentCount
      failedCount
      scheduledAt
      startedAt
      completedAt
      createdAt
    }
  }
`;

export const WHATSAPP_CAMPAIGN_DETAILS_QUERY = gql`
  query WhatsAppCampaignDetails($id: ID!) {
    whatsappCampaign(id: $id) {
      id
      name
      template {
        id
        name
        displayName
        languageCode
      }
      templateParameters
      status
      totalRecipients
      sentCount
      failedCount
      startedAt
      completedAt
      createdAt
      recipients {
        id
        phoneNumber
        status
        whatsappMessageId
        errorMessage
        sentAt
        customer {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`;

export const CUSTOMERS_SEARCH_FOR_CAMPAIGN_QUERY = gql`
  query CustomersSearchForCampaign($first: Int, $after: String, $filter: CustomerFilterInput) {
    customers(first: $first, after: $after, filter: $filter) {
      edges {
        cursor
        node {
          id
          firstName
          lastName
          email
          defaultBillingAddress {
            id
            phone
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const WHATSAPP_MEDIA_FILES_QUERY = gql`
  query WhatsAppMediaFiles($mediaType: WhatsAppMediaType) {
    whatsappMediaFiles(mediaType: $mediaType) {
      id
      fileName
      fileUrl
      fileSize
      mediaType
      createdAt
    }
  }
`;

